import { JetView } from 'webix-jet';

/**
 * Class representing the FilterCurrency.
 * Extends JetView to create a view for filtering currency.
 */
export default class currencyManagementFilter extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        var _ = this.app.getService('locale')._; // Localization service

        // Left section containing input fields for filtering
        var left = {
            margin: 5,
            id: 'a9',
            rows: [
                {
                    margin: 15,
                    paddingY:10,
                    css: 'on-row',
                    responsive: 'a9',
                    cols: [
                        {
                            view: 'text', // Currency
                            minWidth: 200,
                            name: 'Currency',
                            label: _('Currency'),
                            labelPosition: 'top',
                            placeholder: _('Currency'),
                        },
                        {
                            view: 'text', // NumberCode
                            minWidth: 200,
                            name: 'NumberCode',
                            label: _('Código'),
                            labelPosition: 'top',
                            placeholder: _('Código'),
                        },
                        {
                            view: 'richselect', // Dropdown for state selection
                            name: 'State',
                            label: _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'A', value: _('Activo') },
                                { id: 'I', value: _('Inactivo') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left input fields
        var upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Button section for actions
        var buttons = {
            id: 'b2',
            rows: [
                {   
                    margin: 10,
                    paddingY:10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 },
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                var filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('report:filter', [
                                    filterdata, // Trigger filter event with values
                                ]);
                                $$('b5').collapse(); // Collapse the accordion
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section containing filters
        var accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for main form
            },
        };
    }
}
